
    // IMPORTS
    import { defineComponent } from 'vue';
    import { RouterView } from 'vue-router'

    import PortalPage from '@/components/common/portal-page.vue'
    import { buildPartnerNavigation } from '@/util'

    export default defineComponent({
        name: 'partnerView',

        components: {
            PortalPage,
            RouterView
        },

        setup() {
            /********************************************************************************************************************
             INIT
             ********************************************************************************************************************/
            const { navigationItems } = buildPartnerNavigation()

            /********************************************************************************************************************
             COMPONENT INTERFACE
             ********************************************************************************************************************/
            return { navigationItems }
        }
    });
